import { defineStore } from "pinia";
import axios_services from "../axios-services";

export const useSharedFilesStore = defineStore("sharedFiles", {
  state: () => {
    return {
      files: [],
      filesLoading: false,
    };
  },
  getters: {},
  actions: {
    fetchSharedFiles() {
      this.filesLoading = true;
      axios_services
        .get("sharing/with_me")
        .then((response) => {
          this.files = response.data.files;
          this.filesLoading = false;
        })
        .catch((error) => {
          console.log("error: cannot fetch data", error);
          this.filesLoading = false;
        });
    },
  },
});
